// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app/styles/" + chunkId + "." + {"5688":"aee67b47971f239eacc4","8613":"3cb029b77ffdcd934e3a"}[chunkId] + ".css";
};